import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
// @mui
import { Stack } from '@mui/system';
// sections
import Header from './Header';
// reducers
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import { intializeBeneficiary, getBeneficiaryById, getBeneficiaries } from 'state/reducers/beneficiary.reducers';
//components
import { Page } from 'theme/elements/Page';
//constants
import Details from './beneficiaryDetails';
import { CenteredNarrowContent } from 'theme/elements/Content';

export default function BeneficiariesRequestDetails() {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useAppDispatch();
	//get location
	const paths = location.pathname.split('/');
	const lastPath = paths[paths.length - 1];
	const found = useAppSelector(getBeneficiaryById(lastPath));
	const beneficiaries = useAppSelector(getBeneficiaries);
	useEffect(() => {
		if (!_.isEqual(lastPath, 'new') && beneficiaries.length > 0) {
			if (found) {
				dispatch(intializeBeneficiary(found));
			} else {
				navigate('/404');
			}
		}
	}, [beneficiaries]);

	return (
		<Page>
			<Stack spacing={8}>
				<Header />
				<CenteredNarrowContent>
					<Details />
				</CenteredNarrowContent>
			</Stack>
		</Page>
	);
}
